const Masthead = ({ title = "", subtitle = "" }) => {
  return (
    <>
      <div className="container absolute left-1/2 transform -translate-x-1/2 -translate-y-1/2 m-8 bottom-0">
        <h1 className="title-font sm:text-4xl text-3xl font-medium bg-white rounded leading-snug inline px-2 drop-shadow">
          {title}
        </h1>
        {subtitle ? (
          <div className="pt-2">
            <p className="mb-4 leading-tight text-1xl drop-shadow bg-white rounded px-2 bg-white/90 inline">
              {subtitle}
            </p>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default Masthead;
